import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Select,
    Button,
    Modal,
    Typography,
    Tooltip, TooltipTrigger, TooltipContent, TooltipProvider
} from '../../ui/ot'
import { useTranslation } from "react-i18next";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { Plus, X, CircleCheck, SquarePlus, Settings2 } from 'lucide-react';
import LeaderGeneratorModal from "./leader_generator_modal";
import MARC008GeneratorModal from "./marc008_generator_modal";
import PagenationOt from '../../utility/componentOt/views/PagenationOt'
const Marc21Form = ({
    keyPrefix = 'cataloging.AddMARC',
    propsForm,
    field,
    axiosMethod = "post",
    onFormFinish = () => { },
    permission_level = null, 
}) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [count, setCount] = useState(0);
    const [show, setShow] = useState(false)
    const [frameworkValue, setFrameworkValue] = useState("")
    const { t } = useTranslation('translation', { keyPrefix })
    const leader = Form.useWatch('leader', form)
    // const datafield = Form.useWatch('datafield', form)
    // const controlfield = Form.useWatch('controlfield', form)
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        frameworkContainer.getData({})
    };
    const onFinish = (values) => {

        onFormFinish({
            ...values,
        });
    };
    const onValuesChange = (value, { name, type }) => {
        if (name.includes("tag")) {
            setCount(pre => pre + 1)
        }
        else if (name.includes("subfield_string")) {
            let nameArr = name.split(".")
            let thisSubfieldString = form.getFieldValue(name)
            let cleanedInput = thisSubfieldString.startsWith('|') ? thisSubfieldString.slice(1) : thisSubfieldString;
            let parts = cleanedInput.split('|');
            let newSubfield = parts.map((part) => {
                let code = part.charAt(0);
                let text = part.slice(1);
                return {
                    code,
                    text
                }
            })
            let subfieldName = nameArr.map(item => item === "subfield_string" ? "subfield" : item)
            form.setFieldValue(subfieldName.join("."), newSubfield)
        }
        else if (name.includes("subfield")) {
            let nameArr = name.split(".")
            let thisSubfieldName = []
            let flag = 0
            nameArr.forEach((ele) => {
                if (!!flag) {
                    return
                }
                else {
                    if (ele === "subfield") {
                        flag = 1
                    }
                    thisSubfieldName.push(ele)
                }
            })
            let thisSubfield = form.getFieldValue(thisSubfieldName)
            let subfield_string = ""
            thisSubfield?.forEach((element) => {
                subfield_string += `|${element?.code}${element?.text}`
            })
            let subfieldName = thisSubfieldName.map(item => item === "subfield" ? "subfield_string" : item)
            form.setFieldValue(subfieldName.join("."), subfield_string)
        }
    };
    const addSubfield = (fieldName) => {
        let subfieldData = form.getFieldValue(`${fieldName}.subfield`)
        subfieldData.push({
            code: null,
            text: null
        })
        form.setFieldValue(`${fieldName}.subfield`, subfieldData)
    }
    //新增定長欄
    const addControlfieldfield = (fieldName) => {
        let controlfieldData = form.getFieldValue(`controlfield`) || []
        controlfieldData.push({
            tag: null,
            text: null
        })
        form.setFieldValue(`controlfield`, controlfieldData)
    }
    //新增變長欄
    const addDatafield = (fieldName) => {
        let datafieldData = form.getFieldValue(`datafield`) || []
        datafieldData.push({
            ind1: null,
            ind2: null,
            subfield_string: null,
            tag: null,
            subfield: []
        })
        form.setFieldValue(`datafield`, datafieldData)
    }
    const refreshSubfield2subfieldString = (name) => {
        //name 需要是 變更subfield 的任何資訊
        let nameArr = name.split(".")
        let thisSubfieldName = []
        let flag = 0
        nameArr.forEach((ele) => {
            if (!!flag) {
                return
            }
            else {
                if (ele === "subfield") {
                    flag = 1
                }
                thisSubfieldName.push(ele)
            }
        })
        let thisSubfield = form.getFieldValue(thisSubfieldName)
        let subfield_string = ""
        thisSubfield?.forEach((element) => {
            subfield_string += `|${element?.code || ''}${element?.text || ''}`
        })
        let subfieldName = thisSubfieldName.map(item => item === "subfield" ? "subfield_string" : item)
        form.setFieldValue(subfieldName.join("."), subfield_string)

    }
    const changeLeader = (name, value) => {
        form.setFieldValue(name, value)
    }
    const cleanNull = () => {
        let datafield = form.getFieldValue(`datafield`)
        datafield = datafield.filter((datafieldValue) => {
            return !!datafieldValue?.subfield_string
        })
        let controlfield = form.getFieldValue(`controlfield`)
        controlfield = controlfield.filter((controlfieldValue) => {
            return !!controlfieldValue?.text
        })
        form.setFieldValue('datafield', datafield)
        form.setFieldValue('controlfield', controlfield)

    }
    const getTag008 = (count) => {
        let controlfield = form.getFieldValue("controlfield") || []
        let tag008 = controlfield.find((ele) => ele?.tag === "008")?.text || ""
        return tag008
    }
    const setMarcStructure2Marc = (marcStructure) => {
        let controlfieldTag = ['001', '003', '005', '006', '007', '008']
        let controlfield = []
        let datafield = []
        let leader = ""
        leader = marcStructure.find((ele) => ele?.tagfield === "000")?.defaultvalue || ''
        controlfield = marcStructure.filter((ele) => controlfieldTag.includes(ele?.tagfield))
        datafield = marcStructure.filter((ele) => !controlfieldTag.includes(ele?.tagfield) && ele?.tagfield !== "000")
        controlfield = controlfield.map((controlfieldValue) => {
            return {
                tag: controlfieldValue?.tagfield,
                text: ""
            }
        })
        datafield = datafield.map((datafieldValue) => {
            let subfield_string = ""

            let subfield = datafieldValue?.subfield?.map((subfieldValue) => {
                if (!!subfieldValue?.defaultvalue) {
                    subfield_string += `|${subfieldValue?.tagsubfield}${subfieldValue?.defaultvalue}`
                }

                return {
                    "code": subfieldValue?.tagsubfield,
                    "text": subfieldValue?.defaultvalue,
                }
            })

            return {
                tag: datafieldValue?.tagfield,
                ind1: datafieldValue?.ind1_defaultvalue,
                ind2: datafieldValue?.ind1_defaultvalue,
                subfield: subfield,
                subfield_string: subfield_string
            }
        })
        return {
            leader,
            controlfield,
            datafield
        }
    }
    const frameworkContainer = useCRUDController({ apiRoute: "/koha/bib/framework" })
    const marc21TagStructureController = useCRUDController({ apiRoute: "/koha/marc/tagStructure" })
    const changeframeworkValue = (frameworkValue) => {
        marc21TagStructureController.getData({
            frameworkcode: frameworkValue
        }).then((response) => {
            let data = response?.data
            let MARCdata = setMarcStructure2Marc(data)
            if (field?.name) {
                form.setFieldValue(`${field.name}.leader`, MARCdata?.leader)
                form.setFieldValue(`${field.name}.controlfield`, MARCdata?.controlfield)
                form.setFieldValue(`${field.name}.datafield`, MARCdata?.datafield)
            }
            else {
                form.setFieldValue(`leader`, MARCdata?.leader)
                form.setFieldValue(`controlfield`, MARCdata?.controlfield)
                form.setFieldValue(`datafield`, MARCdata?.datafield)
            }
        })
    }
    useEffect(() => {
        setDataInitialization();
    }, []);
    useEffect(() => {
        marc21TagStructureController.getData({
            frameworkcode: frameworkValue
        })
    }, []);


    return (
        <Row>
            <Col  >
                <div className="border-eborder rounded-lg border px-4 py-3">
                    <p className="text-sm">
                        <SquarePlus
                            style={{ backgroundColor: '#388e3c', color: '#c8e6c9' }}
                            className="-mt-0.5 me-3 inline-flex text-emerald-500"
                            size={16}
                            strokeWidth={2}
                            aria-hidden="true"
                        />
                        代表新增定長欄或是變長欄
                    </p>
                    <p className="text-sm">
                        <SquarePlus
                            style={{ backgroundColor: '#c8e6c9', color: '#388e3c' }}
                            className="-mt-0.5 me-3 inline-flex text-emerald-500"
                            size={16}
                            strokeWidth={2}
                            aria-hidden="true"
                        />
                        代表新增變長欄分欄
                    </p>
                    <p className="text-sm">
                        <Settings2
                            className="-mt-0.5 me-3 inline-flex  "
                            size={16}
                            strokeWidth={2}
                            aria-hidden="true"
                        />
                        代表可額外設定
                    </p>
                </div>
            </Col>
            <Col span={24}>
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Row gutter={[8, 8]} justify="end">
                                <Col>
                                    {permission_level === 1 ? 
                                    <Button
                                        onClick={() => {
                                            cleanNull()
                                        }} >
                                        清除空值Tag
                                    </Button>
                                    : <></>}
                                </Col>
                                <Col>
                                    <Button
                                        onClick={() => {
                                            setShow((pre) => !pre)
                                        }} >
                                        {show ? "簡略顯示" : "詳細顯示"}
                                    </Button>
                                </Col>
                                <Col>
                                    {permission_level === 1 ? 
                                    <Button
                                        onClick={() => {
                                            addControlfieldfield()
                                        }} >
                                        新增定長欄
                                    </Button>
                                    : <></>}
                                </Col>

                                <Col>
                                    {permission_level === 1 ? 
                                    <Button
                                        onClick={() => {
                                            addDatafield()
                                        }} >
                                        新增變長欄
                                    </Button>
                                    : <></>}
                                </Col>
                                <Col>

                                </Col>
                            </Row>
                        </Col>
                        {axiosMethod === "post" && <Col span={24}>
                            <Row align={"middle"} gutter={[8, 8]} >
                                <Col >
                                    <Typography.P>
                                        選擇MARC 框架 :
                                    </Typography.P>
                                </Col>
                                <Col>
                                    <Select
                                        options={frameworkContainer.ResponseData.map((value) => {
                                            return {
                                                label: value?.frameworktext,
                                                value: value?.frameworkcode
                                            }
                                        })}
                                        value={frameworkValue}
                                        defaultValue={frameworkValue}
                                        onChange={(value) => {
                                            setFrameworkValue(value)
                                            changeframeworkValue(value)
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Col>}

                        <Col span={24}>
                            <FormItemComponent
                                keyPrefix={keyPrefix}
                                field={field}
                                count={count}
                                setCount={setCount}
                                show={show}
                                addSubfield={addSubfield}
                                refreshSubfield2subfieldString={refreshSubfield2subfieldString}
                                axiosMethod={axiosMethod}
                                leader={leader}
                                tag008={getTag008(count)}
                                // controlfield={controlfield}
                                changeLeader={changeLeader}
                                frameworkcode={frameworkValue}
                                marc21TagStructureData={marc21TagStructureController?.ResponseData}
                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    keyPrefix = 'cataloging.AddMARC',
    field,
    initialValues = {},
    addSubfield = () => { },
    refreshSubfield2subfieldString = () => { },
    changeLeader = () => { },
    setCount = () => { },
    marc21TagStructureData,
    axiosMethod,
    leader,
    tag008,
    controlfield,
    show,
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [leaderForm] = Form.useForm();
    const [marc008Form] = Form.useForm();
    const [pageIndex, setPageIndex] = useState(0)
    const getTagInfo = ({ tag, ResponseData = [] }) => {
        let AlltagInfo = ResponseData.find((ele) => ele?.tagfield === tag)
        return AlltagInfo
    }
    const getTagSubfieldInfo = ({ code, subfieldData = [] }) => {
        let allSubfieldInfo = subfieldData.find((ele) => ele?.tagsubfield === code)
        return allSubfieldInfo

    }

    const marc21TagStructureController = useCRUDController({ apiRoute: "/koha/marc/tagStructure" })


    useEffect(() => {
        let leaderTemp = leader || "     nam a22     7a 4500"
        let initialPatchValue = {
            "f0-4": leaderTemp.slice(0, 5),
            "f5": leaderTemp[5],
            "f6": leaderTemp[6],
            "f7": leaderTemp[7],
            "f8": leaderTemp[8],
            "f9": leaderTemp[9],
            "f10-16": leaderTemp.slice(10, 17),
            "f17": leaderTemp[17],
            "f18": leaderTemp[18],
            "f19": leaderTemp[19],
            "f20-24": leaderTemp.slice(20, 25),
        }
        leaderForm.setFieldsValue({
            ...initialPatchValue
        })

    }, [axiosMethod, leader])

    return (
        <>
            <Row gutter={[4, 4]}>
                <Col span={24} style={{
                    backgroundColor: "#f5f5f5"
                }} >
                    <Row>
                        <Col span={24} >
                            <Row gutter={[4, 4]}>
                                <Col span={24} ></Col>
                                <Col span={18} >
                                    <Form.Item
                                        labelCol={8}
                                        wrapperCol={16}
                                        {...field}
                                        name={[field?.name ?? '', 'leader']}
                                        fieldKey={[field?.fieldKey ?? '', 'leader']}
                                        label={"LEADER"}
                                    >
                                        <Input />
                                    </Form.Item>

                                </Col>
                                <Col  >
                                    <LeaderGeneratorModal
                                        openButtonText=""
                                        axiosMode={axiosMethod}
                                        propsForm={leaderForm}
                                        onFinish={(value) => {
                                            let newLeaderString = ""
                                            Object.keys(value).forEach((key) => {
                                                newLeaderString += value[key]
                                            })
                                            changeLeader([field?.name ?? '', 'leader'].filter(ele => !!ele).join('.'), newLeaderString)
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24} >
                            <Form.List
                                {...field}
                                fieldKey={[field?.fieldKey ?? '', 'controlfield']}
                                name={[field?.name ?? '', 'controlfield']}
                            >
                                {(fields, { add, remove }) => <Row>
                                    {fields.map((field, index) => <Col
                                        style={{
                                            backgroundColor: "#f5f5f5"
                                        }}
                                        span={24}>
                                        <Row gutter={[8, 8]}>
                                            <Col span={24}></Col>
                                            <Col span={8}>
                                                <Form.Item
                                                    labelCol={18}
                                                    wrapperCol={6}
                                                    label={getTagInfo({ tag: field.tag, ResponseData: marc21TagStructureData })?.liblibrarian || " "}
                                                    name={[field.name, 'tag']}
                                                >
                                                    <Input

                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    name={[field.name, 'text']}
                                                >
                                                    <Input
                                                        onChange={() => {
                                                            setCount(pre => pre + 1)
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={4}>
                                                <Row gutter={[4, 4]}>
                                                    <Col>
                                                        <Button
                                                            htmlType="button"
                                                            size="icon"
                                                            style={{ backgroundColor: '#388e3c', color: '#c8e6c9' }}
                                                            onClick={() => { add({}) }}
                                                        >
                                                            <Plus />
                                                        </Button>
                                                        {/* <TooltipProvider>
                                                            <Tooltip>
                                                                <TooltipTrigger   >
                                                                    <div>

                                                                    </div>
                                                                </TooltipTrigger>
                                                                <TooltipContent>
                                                                    <p>{t('add_fixed_field')}</p>
                                                                </TooltipContent>
                                                            </Tooltip>
                                                        </TooltipProvider> */}
                                                    </Col>
                                                    <Col>
                                                        <Button
                                                            size="icon"
                                                            style={{ backgroundColor: '#d32f2f', color: '#ffcdd2' }}
                                                            onClick={() => {
                                                                remove(index)
                                                            }}
                                                        >
                                                            <X />
                                                        </Button>
                                                        {/* <TooltipProvider>
                                                            <Tooltip>
                                                                <TooltipTrigger  >
                                                                    
                                                                </TooltipTrigger>
                                                                <TooltipContent>
                                                                    <p>{t('delete_fixed_field')}</p>
                                                                </TooltipContent>
                                                            </Tooltip>
                                                        </TooltipProvider> */}
                                                    </Col>
                                                    {
                                                        field.tag === "008" && (<Col>
                                                            <MARC008GeneratorModal
                                                                openButtonText=""
                                                                axiosMode={axiosMethod}
                                                                propsForm={marc008Form}
                                                                leader={leader}
                                                                tag008={tag008}
                                                                onFinish={(value) => {
                                                                    let newtag008String = ""
                                                                    Object.keys(value).forEach((key) => {
                                                                        newtag008String += value[key]
                                                                    })
                                                                    changeLeader([field?.name ?? '', 'text'].join('.'), newtag008String)
                                                                }}
                                                                setCount={setCount}
                                                            />
                                                        </Col>)
                                                    }
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>)}
                                </Row>}
                            </Form.List>
                        </Col>
                    </Row>
                </Col>

                <Col span={24} >
                    <Form.List
                        {...field}
                        fieldKey={[field?.fieldKey ?? '', 'datafield']}
                        name={[field?.name ?? '', 'datafield']}
                    >
                        {(fields, { add: datafieldAdd, remove: datafieldRemove }) => <Row gutter={[8, 8]} >
                            <Col span={24}>
                                <PagenationOt
                                    pageIndex={pageIndex}
                                    pageCount={Math.ceil((fields.length || 0) / 20)}
                                    onChange={(value) => {
                                        setPageIndex(value)
                                    }}
                                />
                            </Col>

                            {fields.filter((ele, sortIndex) => {
                                return sortIndex >= 20 * pageIndex && sortIndex < 20 * (pageIndex + 1)
                            }).map((field, index) => <Col
                                style={{
                                    backgroundColor: "#f5f5f5"
                                }} span={24}>
                                <Row gutter={[8, 8]} justify="end"  >
                                    <Col span={24}>

                                    </Col>
                                    <Col span={24} key={field.name} >
                                        <Row gutter={[8, 8]}>
                                            <Col span={8}>
                                                <Form.Item
                                                    label={getTagInfo({ tag: field.tag, ResponseData: marc21TagStructureData })?.liblibrarian || " "}
                                                    labelCol={18}
                                                    wrapperCol={6}
                                                    name={[field.name, 'tag']}
                                                >
                                                    <Input

                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xxl={3} xl={3} lg={3} md={4} sm={4} xs={5}  >
                                                <Row gutter={[2, 2]} align="middle" >
                                                    <Col  >
                                                        <Form.Item
                                                            name={[field.name, 'ind1']}
                                                        >
                                                            <Input
                                                                style={{
                                                                    width: "2.4rem"
                                                                }}
                                                                maxLength={'1'}
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col >
                                                        <Form.Item
                                                            name={[field.name, 'ind2']}
                                                        >
                                                            <Input
                                                                style={{
                                                                    width: "2.4rem"
                                                                }}
                                                                maxLength={'1'}
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xxl={9} xl={9} lg={8} md={8} sm={8}     >
                                                <Form.Item
                                                    name={[field.name, 'subfield_string']}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                            <Col span={4}>
                                                <Row gutter={[4, 4]}>
                                                    <Col>
                                                        <Button
                                                            size="icon"
                                                            style={{ backgroundColor: '#388e3c', color: '#c8e6c9' }}
                                                            onClick={() => datafieldAdd({
                                                                ind1: null,
                                                                ind2: null,
                                                                subfield_string: null
                                                            })}
                                                        >
                                                            <Plus />
                                                        </Button>
                                                        {/* <TooltipProvider>
                                                            <Tooltip>
                                                                <TooltipTrigger  >
                                                                    
                                                                </TooltipTrigger>
                                                                <TooltipContent>
                                                                    <p>{t('add_variable_field')}</p>
                                                                </TooltipContent>
                                                            </Tooltip>
                                                        </TooltipProvider> */}
                                                    </Col>
                                                    <Col>
                                                        <Button
                                                            size="icon"
                                                            style={{ backgroundColor: '#c8e6c9', color: '#388e3c' }}
                                                            onClick={() => addSubfield(field?.name)}
                                                        >
                                                            <Plus />
                                                        </Button>
                                                        {/* <TooltipProvider>
                                                            <Tooltip>
                                                                <TooltipTrigger  >
                                                                   
                                                                </TooltipTrigger>
                                                                <TooltipContent>
                                                                    <p>{t('add_subfield')}</p>
                                                                </TooltipContent>
                                                            </Tooltip>
                                                        </TooltipProvider> */}
                                                    </Col>
                                                    <Col>
                                                        <Button
                                                            size="icon"
                                                            style={{ backgroundColor: '#d32f2f', color: '#ffcdd2' }}
                                                            onClick={() => {
                                                                datafieldRemove((pageIndex) * 20 + index)
                                                            }}
                                                        >
                                                            <X />
                                                        </Button>
                                                        {/* <TooltipProvider>
                                                            <Tooltip>
                                                                <TooltipTrigger  >
                                                                   
                                                                </TooltipTrigger>
                                                                <TooltipContent>
                                                                    <p>{t('delete_variable_field')}</p>
                                                                </TooltipContent>
                                                            </Tooltip>
                                                        </TooltipProvider> */}

                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col
                                        span={24}

                                        hidden={!show}
                                    >
                                        <Form.List
                                            {...field}
                                            fieldKey={[field?.fieldKey ?? '', 'subfield']}
                                            name={[field?.name ?? '', 'subfield']}
                                        >
                                            {(subfields, { add, remove }) => <div>
                                                <Row>
                                                    <Col span={24}>

                                                    </Col>
                                                </Row>
                                                {subfields.map((subfield, subfieldIndex) => <>
                                                    <Row key={subfield.name} gutter={[8, 8]}>
                                                        <Col span={24}></Col>
                                                        <Col span={10}>
                                                            <Form.Item
                                                                labelCol={20}
                                                                wrapperCol={4}
                                                                label={
                                                                    getTagSubfieldInfo({
                                                                        code: subfield?.code,
                                                                        subfieldData:
                                                                            getTagInfo({
                                                                                tag: field.tag,
                                                                                ResponseData: marc21TagStructureData,
                                                                            })?.subfield || []

                                                                    })?.liblibrarian || " "}
                                                                name={[subfield.name, 'code']}

                                                            >
                                                                <Input />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={10}>
                                                            <Form.Item
                                                                name={[subfield.name, 'text']}
                                                            >
                                                                <Input />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={4}>
                                                            <Row gutter={[2, 2]}>
                                                                <Col>
                                                                    <Button
                                                                        size="icon"
                                                                        style={{ backgroundColor: '#c8e6c9', color: '#388e3c' }}
                                                                        onClick={() => add({})}
                                                                    >
                                                                        <Plus />
                                                                    </Button>
                                                                    {/* <TooltipProvider>
                                                                        <Tooltip>
                                                                            <TooltipTrigger  >
                                                                                
                                                                            </TooltipTrigger>
                                                                            <TooltipContent>
                                                                                <p>{t('add_subfield')}</p>
                                                                            </TooltipContent>
                                                                        </Tooltip>
                                                                    </TooltipProvider> */}
                                                                </Col>
                                                                <Col>
                                                                    <Button
                                                                        size="icon"
                                                                        style={{ backgroundColor: '#ffcdd2', color: '#d32f2f' }}
                                                                        onClick={() => {
                                                                            remove(subfieldIndex)
                                                                            refreshSubfield2subfieldString(subfield.name)
                                                                        }}
                                                                    >
                                                                        <X />
                                                                    </Button>
                                                                    {/* <TooltipProvider>
                                                                        <Tooltip>
                                                                            <TooltipTrigger  >
                                                                                
                                                                            </TooltipTrigger>
                                                                            <TooltipContent>
                                                                                <p>{t('delete_subfield')}</p>
                                                                            </TooltipContent>
                                                                        </Tooltip>
                                                                    </TooltipProvider> */}

                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </>)}
                                            </div>}
                                        </Form.List>
                                    </Col>
                                </Row>
                            </Col>)}
                        </Row>}
                    </Form.List>
                </Col>
            </Row >
        </>
    );
};

// Dependencies: pnpm install lucide-react


export default Marc21Form;
